<style scoped lang="less">
.chart-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    padding-left: 20px;
    padding-right: 20px;
    box-sizing: border-box;
    .myChart {
        width: 100%;
        height: 500px;
        margin-top: 50px;
        margin-bottom: 50px;
    }
}
</style>

<template>
    <div class="yb-container">
        <div class="line-container">
            <el-date-picker v-model="date" @change="fetchData2" type="week" format="yyyy 第 WW 周" placeholder="选择周" :picker-options="{'firstDayOfWeek':1}" size="mini" :clearable="false"></el-date-picker>
        </div>
        <div class="chart-container" v-loading="loading">
            <div id="chartNow" class="myChart"></div>
        </div>
        <div class="chart-container" v-loading="loading">
            <div id="chartWeek" class="myChart"></div>
        </div>
        <div class="line-container block-top">
            <el-date-picker v-model="dateMonth" @change="fetchData" type="monthrange" range-separator="至" start-placeholder="开始月份" end-placeholder="结束月份">
            </el-date-picker>
        </div>
        <div class="chart-container" v-loading="loading">
            <div id="chartMonth" class="myChart"></div>
        </div>
    </div>
</template>

<script>
import PagedTable from "../components/PagedTable.vue";
import { HttpClient } from "../util/http";
import { actionConfirm, msgError, msgSuccess } from "../util/toast";
import * as echarts from "echarts";

export default {
    components: {},
    mixins: [],
    data() {
        return {
            weekData: [],
            monthData: [],
            nowData: [],
            loading: false,
            chartNow: null,
            chartWeek: null,
            chartMonth: null,
            date: dayjs(),
            dateMonth: [dayjs().subtract(6, "month"), dayjs()],
        };
    },
    created() {
        this.fetchData();
        this.fetchData2();
    },
    mounted() {},
    computed: {},
    mounted() {},
    methods: {
        async fetchData2() {
            this.loading = true;
            let res = await HttpClient.post("/order/chart2", {
                date: dayjs(this.date)
                    .startOf("week")
                    .add(7, "day")
                    .format("YYYY-MM-DD"),
            });
            this.loading = false;
            this.nowData = res;
            this.$nextTick(() => {
                this.drawLineNow();
            });
        },
        async fetchData() {
            this.loading = true;
            let res = await HttpClient.post("/order/chart", {
                dateMonth: this.dateMonth,
            });
            this.loading = false;
            this.weekData = res.weekData;
            this.monthData = res.monthData;
            this.$nextTick(() => {
                this.drawLineWeek();
                this.drawLineMonth();
            });
        },
        drawLineNow() {
            if (!this.chartNow) {
                this.chartNow = echarts.init(
                    document.getElementById("chartNow")
                );
            }

            this.chartNow.setOption({
                title: {
                    text: "本周/本月 单量/折算业绩",
                },
                label: {
                    show: true,
                    position: "top",
                },
                toolbox: {
                    feature: {
                        saveAsImage: {},
                    },
                },
                legend: {},
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "shadow",
                        label: {
                            show: true,
                            formatter: function (params) {
                                return params.value.replace("\n", "");
                            },
                        },
                    },
                },
                dataset: {
                    source: this.nowData,
                },
                xAxis: {
                    type: "category",
                    axisLabel: {
                        // 坐标轴标签
                        show: true, // 是否显示
                        inside: false, // 是否朝内
                        rotate: 0, // 旋转角度
                        interval: 0,
                    },
                },
                yAxis: {},
                series: [
                    {
                        type: "bar",
                        name: this.nowData[0][1],
                        emphasis: {
                            focus: "series",
                        },
                    },
                    {
                        type: "bar",
                        name: this.nowData[0][2],
                        emphasis: {
                            focus: "series",
                        },
                    },
                    {
                        type: "bar",
                        name: this.nowData[0][3],
                        emphasis: {
                            focus: "series",
                        },
                    },
                    {
                        type: "bar",
                        name: this.nowData[0][4],
                        emphasis: {
                            focus: "series",
                        },
                    },
                ],
            });
        },
        drawLineMonth() {
            if (!this.chartMonth) {
                this.chartMonth = echarts.init(
                    document.getElementById("chartMonth")
                );
            }

            let x = [];
            //开始月份
            let startMonth = this.dateMonth[0];
            //结束月份
            let endMonth = this.dateMonth[1];
            //月份数
            let monthCount =
                dayjs(endMonth).diff(dayjs(startMonth), "month") + 1;
            for (let i = monthCount - 1; i >= 0; i--) {
                let date = dayjs(endMonth).subtract(i, "month").format("M月");
                x.push(date);
            }
            let option = {
                title: {
                    text: "月度 折算业绩",
                },
                tooltip: {
                    trigger: "axis",
                },
                legend: {
                    data: this.monthData.map((it) => it.name),
                },
                grid: {
                    left: "3%",
                    right: "4%",
                    bottom: "3%",
                    containLabel: true,
                },
                toolbox: {
                    feature: {
                        saveAsImage: {},
                    },
                },
                xAxis: {
                    type: "category",
                    boundaryGap: false,
                    data: x,
                },
                yAxis: {
                    type: "value",
                },
                series: this.monthData.map((it) => {
                    return {
                        name: it.name,
                        type: "line",
                        data: it.data,
                        label: { show: true },
                    };
                }),
            };
            this.chartMonth.setOption(option);
        },
        drawLineWeek() {
            if (!this.chartWeek) {
                this.chartWeek = echarts.init(
                    document.getElementById("chartWeek")
                );
            }

            //今天
            let now = dayjs().format("YYYY-MM-DD");
            //本周一
            let nowMonday = dayjs(now).startOf("week").add(1, "day");
            //本周日
            let nowSunday = nowMonday.add(6, "day");

            let x = [];
            for (let i = this.weekData[0].data.length - 1; i >= 0; i--) {
                let date =
                    dayjs(nowMonday).subtract(i, "week").format("M.D") +
                    "~" +
                    dayjs(nowSunday).subtract(i, "week").format("M.D");
                x.push(date);
            }
            let option = {
                title: {
                    text: "周度 折算业绩",
                },
                tooltip: {
                    trigger: "axis",
                },
                legend: {
                    data: this.weekData.map((it) => it.name),
                },
                grid: {
                    left: "3%",
                    right: "4%",
                    bottom: "3%",
                    containLabel: true,
                },
                toolbox: {
                    feature: {
                        saveAsImage: {},
                    },
                },
                xAxis: {
                    type: "category",
                    boundaryGap: false,
                    data: x,
                },
                yAxis: {
                    type: "value",
                },
                series: this.weekData.map((it) => {
                    return {
                        name: it.name,
                        type: "line",
                        data: it.data,
                        label: { show: true },
                    };
                }),
            };
            this.chartWeek.setOption(option);
        },
    },
};
</script>
